export enum CoreActionKeys {
  APP_INITIALIZED = 'APP_INITIALIZED',
  INIT_APP = 'INIT_APP'
}
